"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keyMirrorArray;
function keyMirrorArray(array) {
  var result = {};

  array.forEach(function (item) {
    result[item] = item;
  });

  return result;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-foundation-components/lib/util/key-mirror-array/index.js
 ** module id = 1051
 ** module chunks = 0
 **/